module.exports = __webpack_public_path__ + "img/PRCA2_Mono.Macro.2d750622.png";